import { toMs } from '../../lib/toMs'

export const msToMinutes = (ms: number | string) => {
  const parsedMs = typeof ms === 'number' ? ms : ms ? parseInt(ms) : 0
  const checkedMs = isNaN(parsedMs) ? 0 : parsedMs
  return Math.round(checkedMs / toMs({ minutes: 1 })) || 0
}
